import React from 'react';
import './MyMapsSymbolizer.css';

export const PointType = (props) => {
  return (
    <React.Fragment>
      <label className={props.visible ? 'fs-mymaps-style-label' : 'fs-hidden'}>
        Stil:
      </label>
      <select
        className={props.visible ? 'fs-mymaps-style-dropdown' : 'fs-hidden'}
        name="pointSymbols"
        value={props.selectedPointStyleDropDown}
        onChange={props.onPointStyleDropDown}
      >
        <option value="circle">Krug</option>
        <option value="cross">Križ</option>
        <option value="square">Kvadrat</option>
        <option value="triangle">Trokut</option>
        <option value="star">Zvijezda</option>
        <option value="x">x</option>
      </select>
    </React.Fragment>
  );
};

export const PolygonType = (props) => {
  return (
    <React.Fragment>
      <label className={props.visible ? 'fs-mymaps-style-label' : 'fs-hidden'}>
        Style:
      </label>
      <select
        className={props.visible ? 'fs-mymaps-style-dropdown' : 'fs-hidden'}
        name="polygonSymbols"
        value={props.selectedPolygonStyleDropDown}
        onChange={props.onPolygonStyleDropDown}
      >
        <option value="none">None</option>
        <option value="solid">Solid</option>
        <option value="horizontal">Horizontal</option>
        <option value="vertical">Vertical</option>
        <option value="cross">Cross</option>
      </select>
    </React.Fragment>
  );
};

export const StyleSize = (props) => {
  return (
    <React.Fragment>
      <label className={props.visible ? 'fs-mymaps-sub-label' : 'fs-hidden'}>
        Veličina:
      </label>
      <div
        className={
          props.visible ? 'fs-mymaps-symbolizer-slider size' : 'fs-hidden'
        }
      >
        <input
          type="range"
          style={{ width: '169px' }}
          min={props.sliderRadiusMin}
          max={props.sliderRadiusMax}
          value={props.radius}
          step="1"
          onChange={props.onRadiusSliderChange}
        />
      </div>
    </React.Fragment>
  );
};

export const FillColor = (props) => {
  return (
    <React.Fragment>
      <label
        className={
          !props.visible
            ? 'fs-hidden'
            : props.isPolygon
            ? 'fs-mymaps-style-label'
            : 'fs-mymaps-sub-label'
        }
      >
        Boja:
      </label>
      <div
        className={props.visible ? 'fs-mymaps-fill-color-button' : 'fs-hidden'}
      >
        <button
          id={props.colorPickerButtonId}
          style={{
            backgroundColor: props.rgbFill,
            width: '30px',
            height: '15px',
            cursor: 'pointer',
          }}
          onMouseUp={props.onFillColorPickerButton}
        />
        <div className="fs-mymaps-symbolizer-slider opacity">
          <input
            key={'fs-mymaps-symbolizer-fill-opacity'}
            type="range"
            style={{ width: '138px' }}
            min={props.sliderFillOpacityMin}
            max={props.sliderFillOpacityMax}
            value={props.fillAlpha}
            step="0.05"
            onChange={props.onFillOpacitySliderChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export const StrokeType = (props) => {
  return (
    <React.Fragment>
      <label className="fs-mymaps-style-label">Kontura:</label>
      <select
        className="fs-mymaps-style-dropdown"
        name="pointOutline"
        value={props.selectedStrokeTypeDropDown}
        onChange={props.onStrokeTypeDropDown}
      >
        <option value="normal">Normalna</option>
        <option value="dash">Isprekidana</option>
        <option value="dot">Tačkasta</option>
      </select>
    </React.Fragment>
  );
};

export const StrokeColor = (props) => {
  return (
    <React.Fragment>
      <label className="fs-mymaps-sub-label">Boja:</label>
      <div className="fs-mymaps-fill-color-button">
        <button
          id={props.colorPickerButtonId}
          style={{
            backgroundColor: props.rgbStroke,
            width: '30px',
            height: '15px',
            cursor: 'pointer',
          }}
          onMouseUp={props.onStrokeColorPickerButton}
        />
        <div className="fs-mymaps-symbolizer-slider opacity">
          <input
            key={'fs-mymaps-symbolizer-stroke-opacity'}
            type="range"
            style={{ width: '138px' }}
            min={props.sliderStrokeOpacityMin}
            max={props.sliderStrokeOpacityMax}
            value={props.strokeAlpha}
            step="0.05"
            onChange={props.onStrokeOpacitySliderChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export const StrokeWidth = (props) => {
  return (
    <React.Fragment>
      <label className="fs-mymaps-sub-label">Širina:</label>
      <div className="fs-mymaps-symbolizer-slider size">
        <input
          type="range"
          style={{ width: '169px' }}
          min={props.sliderStrokeWidthMin}
          max={props.sliderStrokeWidthMax}
          value={props.strokeWidth}
          step="0.5"
          onChange={props.onStrokeWidthSliderChange}
        />
      </div>
    </React.Fragment>
  );
};

export const Rotation = (props) => {
  return (
    <React.Fragment>
      <label className={props.visible ? 'fs-mymaps-style-label' : 'fs-hidden'}>
        Rotacija:
      </label>
      <div className={props.visible ? 'fs-mymaps-angle-slider' : 'fs-hidden'}>
        <div className="fs-mymaps-symbolizer-slider angle">
          <input
            type="range"
            min={props.sliderRotationMin}
            max={props.sliderRotationMax}
            value={props.rotation}
            step="0.1"
            onChange={props.onRotationSliderChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
